// @ts-nocheck
import { SnackbarProvider } from 'notistack'
import { RouterProvider } from 'react-router-dom'
import ThemeProviderCustom from './provider/ThemeProviderCustom'
import { router } from './router'
import '@fortawesome/fontawesome-pro-light'
import '@fortawesome/fontawesome-pro-solid'
import DevTenantSwitcher from './components/dev/DevTenantSwitcher'
import { isDevTenantEnabled } from './config/devTenant'

function App() {
  return (
    <ThemeProviderCustom>
      <SnackbarProvider maxSnack={3}>
        <RouterProvider router={router} />
        {/* MF-560 — local development only (never in a build) */}
        {isDevTenantEnabled && <DevTenantSwitcher />}
      </SnackbarProvider>
    </ThemeProviderCustom>
  )
}

export default App
